<template>
	<div>
		<div class="d-flex justify-content-between">
			<!-- <div class="d-flex">
				<div class="blue_header pointer">
					<span>List View</span>
				</div>
				<div class="blue_header_triangle pointer"></div>
			</div> -->
            <div class="tabs tabs-style-shape">
                <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                    </defs>
                </svg>
                <nav>
                    <ul class="ml-0">
                        <li class="tab-current">
                            <a href="javascript:;" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span>List View</span>
                            </a>
                        </li>
                        <!-- For styling we need this tag  -->
                        <li style="width: 0px !important;flex: 0 !important;">
                            <a href="#section-shape-3" style="margin: 0;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
			<div class="d-flex" style="flex-grow: 1">
				<div class="d-flex mx-0" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
					<i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                    <i v-if="sales_search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
					<input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="sales_search_key" v-debounce:500ms="searchSalesForecast" debounce-events="input" placeholder="Search by Forecast Name" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
				</div>
			</div>
		</div>
        <!-- Filter Chips Section -->
		<div class="table-block pt-10" style="background-color:#fff;border-top-right-radius:5px">
            <div class="filterSelectedChips mb-3" v-if="showfilterData.sale_forecast_name.length || showfilterData.territory.length || showfilterData.product_id.length || showfilterData.forecast_period.length || showfilterData.status.length || showfilterData.targeted_sale || showfilterData.actual_sale">
				<div class="pull-right pointer resetChips" style="bottom: 7px !important;" @click="removeAllChips()"><i class="icon icon-close text-white fs-20"></i></div>
				<div class="d-flex align-items-center flex-wrap">
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.sale_forecast_name.length">Sales Forecast Name</span>
					<span v-for="(name,sf_index) in showfilterData.sale_forecast_name" :key="sf_index" class="mt-2">
						<span class="filterChips" @click="removeChips(name,'sales_forecast_name')">
							{{name.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.territory.length">Territory</span>
					<span v-for="(territory,territory_index) in showfilterData.territory" :key="territory_index" class="mt-2">
						<span class="filterChips" @click="removeChips(territory,'territory')">
							{{territory.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.product_id.length">Product</span>
					<span v-for="(product_id,product_index) in showfilterData.product_id" :key="product_index" class="mt-2">
						<span class="filterChips" @click="removeChips(product_id,'product_id')">
							{{product_id.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.forecast_period.length">Forecast Period</span>
					<span v-for="(forecast_period,forecast_period_index) in showfilterData.forecast_period" :key="forecast_period_index" class="mt-2">
						<span class="filterChips text-capitalize" @click="removeChips(forecast_period,'forecast_period')" >
							{{forecast_period.replace('_',' ')}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.status.length">Status</span>
					<span v-for="(status,status_index) in showfilterData.status" :key="status_index" class="mt-2">
						<span class="filterChips text-capitalize" @click="removeChips(status,'status')">
							{{status}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.targeted_sale">Targeted Sale</span>
					<span class="filterChips" v-if="showfilterData.targeted_sale" @click="removeChips(showfilterData.targeted_sale,'targeted_sale') " >
						{{showfilterData.targeted_sale}}
						<i class="icon icon-close fs-12"></i>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.actual_sale">Actual Sale</span>
					<span class="filterChips" v-if="showfilterData.actual_sale" @click="removeChips(showfilterData.actual_sale,'actual_sale')" >
						{{showfilterData.actual_sale}}
						<i class="icon icon-close fs-12"></i>
					</span>
				</div>
			</div>
            <!-- List View Table Section -->
			<table class="team-listview-table w-100 table-responsive">
				<thead>
					<tr>
                        <th style="width: 10px !important;padding: 13px 18px !important"></th>
						<th width="10%">SALE FORECAST NAME</th>
						<th width="10%" v-if="loggedInUser.user_role == 'sales_person'">ASSIGNED BY</th>
						<th width="10%">TARGETED SALE ({{currency}})</th>
						<th width="10%">ACTUAL SALE ({{currency}})</th>
						<th width="10%">MARGIN ({{currency}})</th>
						<th width="10%">PRODUCT</th>
						<th width="10%">TERRITORY</th>
						<th width="15%">STATUS</th>
					</tr>
				</thead>
				<tbody>
                    <tr class="w-100" v-if="ajax_call_in_progress && !list_view_sales.length">
                        <td colspan="6">
                            <div class="d-flex w-100" v-if="ajax_call_in_progress">
                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!ajax_call_in_progress && list_view_sales.length == 0" class="text-center font-weight-bold" style="height: 400px;">
                        <td colspan="6">
                            <img src="/static/images/contact-list.png" class="mb-3" style="width: 25%!important; height: 50%!important;"/>
                        <div class="text-center">No Sales Forecast added!</div>
                    </td>
                    </tr>
					<tr v-else v-for="(sales, sales_index) in list_view_sales" :key="sales_index">
                        <td style="width: 10px !important;padding: 13px 18px !important">
                            <div @click="assignTarget(sales.id)" v-show="loggedInUser.user_role != 'sales_person' && userPermissions.sales_forecast.permitted_actions.edit" class="pointer" :class="{'v-hidden':(sales.status !='un_assigned' && sales.status != 'need_to_assign' && sales.status != 'assigned')}">
                                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                    <button class="pointer btn-icon pt-3" style="padding:0px!important;">
                                        <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                    </button>
                                </el-tooltip>
                            </div>
                        </td>
						<td class="text-capitalize new-blue-text pointer text-truncate cust-max-width" @click="selectedSalesForecast(sales.id)" :title="sales.name">{{sales.name}}</td>
                        <td v-if="loggedInUser.user_role == 'sales_person'">{{sales.assigned_by_person}}</td>
						<td>{{sales.target}}</td>
						<td>{{sales.total_sales}}</td>
						<td>{{sales.margin}}</td>
						<td>{{sales.product_name || '-'}}</td>
						<td>
                            <el-tooltip class="item" effect="dark" :content="sales.territory" placement="top">
                                <span class="text-ellipsis">{{sales.territory || '-'}}</span>
                            </el-tooltip>
                        </td>
						<td>
                            <button v-if="sales.status=='active'" class="btn active-btn status-btn">Active</button>
                            <button v-if="sales.status=='assigned'" class="btn assigned-btn status-btn">Assigned</button>
                            <button v-if="sales.status=='need_to_assign'" class="btn assigned-btn status-btn">Need to Assign</button>
                            <button v-if="sales.status=='un_assigned'" class="btn btn-outline-secondary assign-btn status-btn">Assign Target</button>
                            <button v-if="sales.status=='completed'" class="btn completed-btn status-btn">Completed</button>
                            <button v-if="sales.status=='un_achieved'" class="btn unachieved-btn status-btn">Unachieved</button>
                        </td>
					</tr>
				</tbody>
			</table>
		</div>
        <!-- Pagination Section -->
		<div v-if="list_view_sales.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4 mb-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
            <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                :options="pageLimit" :close-on-select="true" v-model.number="limit"
                :max-height="210" :allow-empty="false" :searchable="false"
                open-direction="top" :show-labels="false" placeholder=""
                style="width: 4.2em !important;padding-right: 10px!important;">
            </multiselect>
            <span class="page-info pr-2 pl-3 fw-500 text-dark font-size-small">Per page</span>
            <button @click="firstPage()" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                    <i class="icon-chevron-double-left"></i>
                </el-tooltip>
            </button>
            <button @click="previousPage()" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                    <i class="icon icon-chevron-left"></i>
                </el-tooltip>
            </button>
            <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} -
                {{total>skip+limit?skip+limit:total}} of {{total}}</span>
            <button @click="nextPage()" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total"
                class="pagination-list mt-1 mr-2 pointer">
                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                    <i class="icon icon-chevron-right"></i>
                </el-tooltip>
            </button>
            <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                    <i class="icon-chevron-double-right"></i>
                </el-tooltip>
            </button>
        </div>
	</div>
</template>

<script>
import salesforecast from "../mixins/salesforecast";
import { EventBus } from '../eventBus/nav-bar-event';
import { SweetModal } from 'sweet-modal-vue';
import { HalfCircleSpinner } from "epic-spinners";
export default {
	mixins:[salesforecast],
    components: {
        HalfCircleSpinner
    },
	data() {
		return {
            currency:'',
			pageLimit: [],
			view_sale: false,
			list_view_sales: [],
			warning_msg: '',
            success_msg: '',
            skip: 0,
            limit: 10,
            count: 0,
            start: 0,
            search_key: '',
            end: 0,
            total: 0,
            skip_temp: 0,
            temp_total: 0,
            ajax_call_in_progress: false,
            filter_json: {},
            sales_search_key: '',
            display_filters: false,
            filters: {
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
            },
            showfilterData:{
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
			},
		}
	},
	methods: {
        clearSearch(){
            this.sales_search_key = ""
            this.search_key = "";
            this.$refs.searchInput.focus();
            this.getSalesListView();
        },
        assignTarget(id){
            this.$emit("assignTarget",id)
        },
		selectedSalesForecast(id) {
            if(this.userPermissions.sales_forecast.permitted_actions.view){
                this.$router.push("/salesForeCast/view_sales_forecast/"+id)
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
		},
		async getSalesListView() {
            this.list_view_sales = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit == "" || this.limit == null || this.limit == undefined || this.limit == 0 || this.limit < 0 ? 10 : this.limit,
                    search_key: this.search_key,
                    filter_json: this.filter_json
                }
                this.list_view_sales = [];
                let response = await this.listSalesForeCast(params);
                this.list_view_sales = response.response;
                this.total = response.count;
                this.$forceUpdate()
                this.$store.commit("setSalesForecastLength",this.list_view_sales.length)
                this.ajax_call_in_progress = false;
            }
            catch(error) {
                this.ajax_call_in_progress = false;
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
		previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getSalesListView();
            this.check_all = false;
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.check_all = false;
            this.getSalesListView();
        },
        firstPage() {
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            // this.list_view_data = []
            this.check_all = false;
            this.getSalesListView();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total / this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.check_all = false;
            this.getSalesListView();
        },
        searchSalesForecast() {
            this.skip = 0;
            this.search_key = this.sales_search_key;
            this.getSalesListView();
        },
        removeChips(value,key){
            let params = {
                value:value,
                key:key
            }
            EventBus.$emit('removechip',params)
        },
        removeAllChips(){
            this.filters = {
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
            }
            this.showfilterData = {
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
            }
            EventBus.$emit('removeAllchip')
            if(!this.display_filters) {
                // EventBus.$emit("load_sales_forecast",this.filters)
                this.getSalesListView()
            }
		},
	},
	computed: {
        getSkipCount() {
            if (this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                return skip_count;
            }
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        userPermissions(){
			return this.$store.getters.userPermissions;
		}
    },
    mounted() {
        this.currency = this.loggedInUser.currency.symbol;
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.getSalesListView();
        EventBus.$on("load_sales_forecast",(value) => {
            this.filter_json = value
            this.getSalesListView()
        })
        EventBus.$on("filter_sales_forecast",(value) => {
            this.showfilterData = value
            // this.getSalesListView()
        })
    },
    watch:{
        limit: function(){
            this.getSalesListView();
        }
    },
};
</script>

<style scoped>
	.team-listview-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-listview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-listview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-listview-table tbody tr td {
        background: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-listview-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
	.status-btn{
		border-radius: 8px !important;
		width: 140px !important;
        text-transform: capitalize !important;
	}
    .active-btn{
        background-color: #206ad3 !important;
        border-color: #206ad3 !important;
        will-change: box-shadow !important;
        color: #fff!important;
    }
    .assigned-btn{
        background-color: #ff9a35 !important;
        border-color: #ff9a35 !important;
        will-change: box-shadow !important;
        color: #fff!important;
    }
    .completed-btn{
        background-color: #038b64 !important;
        border-color: #038b64 !important;
        will-change: box-shadow !important;
        color: #fff!important;
    }
    .unachieved-btn{
        background-color: #fa0b17 !important;
        border-color: #fa0b17 !important;
        will-change: box-shadow !important;
        color: #fff!important;
    }
    .assign-btn{
        color: #005dae !important;
        background-color: transparent;
        background-image: none;
        border-color: #005dae !important;
        will-change: box-shadow !important;
    }
    .cust-max-width{
        max-width: 410px;
    }
    .text-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        width: 200px;
        display: block;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 130px !important;
        max-width: 130px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SalesForeCast/ListView.vue